export default __webpack_public_path__ + "static/media/qr-generate.f3a08613.svg";